import * as kendoThemeChooser from "../KednoThemeChooser";
import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "./DashBoardResultSetUtil";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createColsWithCategsAndLabelsChart(userDashboardChartLine, h, w, widget, chartArea) {
    let seriesData = [];
    let dataSource = [];
    let categsWithData = constructMapOfCategLabelsValues(userDashboardChartLine);
    if (categsWithData.entries()) {
        for (let [categ, data] of categsWithData.entries()) {
            seriesData.push({name: categ, data: data});
        }
        if (seriesData.length)
            dataSource = seriesData[0].data;
    }
    widget.kendoChart({
        dataSource: dataSource,
        theme: kendoThemeChooser.currentTheme(),
        legend: {
            position: "bottom"
        },
        seriesDefaults: {
            type: "column",
            labels: {
                visible: true,
            }
        },
        categoryAxis: [{
            field: "label",
            labels: {
                visible: true
            }
        }],
        series: seriesData,
        chartArea: chartArea,
        valueAxis: {
            labels: {
                template: "#= value/1000 #K"
            },
            title: {
                text: calcChartTitle(userDashboardChartLine),
                margin: 15,
                font: "12px",
            }
        },
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= category #<br> #= value #"
        }
    });
    return widget;
}

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @return {*}
 */
export function constructMapOfCategLabelsValues(userDashboardChartLine) {
    let params = userDashboardChartLine.parameters;
    let resultSetValues = userDashboardChartLine.resultSet;
    let categsWithData = new Map();
    let labelParam = params[DashboardConstants.Param_Label];
    let valueParam = params[DashboardConstants.Param_Value];
    let categParam = params[DashboardConstants.Param_Category];
    for (let i = 0; i < resultSetSize(resultSetValues); i++) {
        let label = getByColName(i, labelParam, resultSetValues);
        let value = getByColName(i, valueParam, resultSetValues);
        let categ = getByColName(i, categParam, resultSetValues);
        if (!categsWithData.get(categ))
            categsWithData.set(categ, []);
        categsWithData.get(categ).push({label: label, value: value});
    }
    return categsWithData;
}